import { render, staticRenderFns } from "./table-info-add.vue?vue&type=template&id=43b2a672&scoped=true&"
import script from "./table-info-add.vue?vue&type=script&lang=ts&"
export * from "./table-info-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b2a672",
  null
  
)

export default component.exports